export default function PHP_array_column() {
  return (
    <div>
      <h1>PHP_array_column</h1>
    </div>
  );
}
